import { computed, getCurrentInstance } from "@vue/composition-api";
import store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import AppStorage from "@/lib/appStorage";
import { IS_BROWSER } from "@/lib/browserUtils";
import config from "@/config";

enum controlClass {
  DARK = "dark-mode",
  LIGHT = "",
}
export const STORAGE_KEY = "DARK_MODE";
export const DARK_MODE_MEDIA_QUERY = "(prefers-color-scheme: dark)";
export const DEFAULT_DARK_MODE_VALUE = false;

export default function useDarkModeController() {
  const vm = getCurrentInstance();
  const isDarkMode = computed<StateRoot["darkMode"]>(() => {
    if (config.featureDarkMode) return (vm?.$store.state as StateRoot).darkMode;
    return DEFAULT_DARK_MODE_VALUE;
  });

  const changeControlClass = (): void => {
    if (!IS_BROWSER) return;

    isDarkMode.value
      ? (document.documentElement.className = controlClass.DARK)
      : (document.documentElement.className = controlClass.LIGHT);
  };

  const changeDarkModeValue = (isDark: boolean): void => {
    AppStorage.setBoolean(STORAGE_KEY, isDark);
    store.commit(MUTATION_TYPES.SET_DARK_MODE, isDark);
    changeControlClass();
  };

  const hasValueInStore = (): boolean => AppStorage.getKeys().includes(STORAGE_KEY);
  const toggleDarkMode = (): void => changeDarkModeValue(!isDarkMode.value);

  const init = (): void => {
    if (!config.featureDarkMode) return;

    if (hasValueInStore()) {
      changeDarkModeValue(AppStorage.getBoolean(STORAGE_KEY, DEFAULT_DARK_MODE_VALUE));
      return;
    }

    if (!IS_BROWSER) changeDarkModeValue(DEFAULT_DARK_MODE_VALUE);
    else changeDarkModeValue(window.matchMedia(DARK_MODE_MEDIA_QUERY).matches);
  };

  return {
    isDarkMode,
    init,
    toggleDarkMode,
  };
}
